<template>
  <div>
    <div class='main-style-open' v-bind:class="{'main-style-close': isCollapse}" style="height: 100%; width: 100%;">
      <el-container style="height: 100vh!important;">
        <!-- <aside class="my-aside" v-bind:class="{'my-aside-hidden': isCollapse}"> -->
        <aside class="my-aside">
          <!-- 侧栏 -->
          <el-menu
            :default-active="$route.path" 
            class="el-menu-vertical-demo" 
            style="height: 100vh!important; border: none; text-align:left;overflow: scroll; "
            background-color="#191a23" 
            text-color="#fff" 
            active-text-color="#409EFF" 
            :collapse="isCollapse"
            router
            >
             
            <div class="fix-title">
              <img class="logoimg" src="https://www.gin-vue-admin.com/img/logo.png">
              <h2 class="title-txt" v-bind:class="{displaynone: isCollapse}" style="color: rgb(255,255,255);">轻舍茶馆</h2>
              <!-- <h2 class="title-txt" style="color: rgb(255,255,255);">轻舍茶馆</h2> -->
            </div>
            
            <el-menu-item index="/main" >
              <i class="el-icon-s-home"></i>
              <span slot="title">首页</span>
            </el-menu-item>
            
             <el-submenu v-for="(item,index) in menuList" :key="index" :index='item.id'>
              <template slot="title">
                <i :class="item.icon"></i>
                <span>{{item.title}}</span>
              </template>
              
              <el-menu-item v-for="child in item.children" :key="child.id" :index='child.index'>
                
                <i :class="child.icon"></i>
                <span>{{child.childtitle}}</span>
              </el-menu-item>
              
            </el-submenu>
            
          </el-menu>
        </aside>
        

        <!-- <el-container class="main-container" v-bind:class="{'main-container-hidden': isCollapse}"> -->
        <el-container class="main-container">
          <el-header style="font-size: 12px; background-color: #fff; ">
            
            <div class="is-open-close-btn" @click="OpenCloseTable()">
              <i class="el-icon-s-unfold" v-if="isCollapse" style="--font-size:24px;"></i>
              <i class="el-icon-s-fold" v-else style="--font-size:24px;"></i>
            </div>
            
            <div style="text-align: right; position: relative; float: right; width: 60px;"> 
              <el-dropdown>
                <div class="user-icon-div">
                  <img class="user-icon" :src=avatar>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-setting">
                    <span @click="user_personal()">个人中心</span>
                  </el-dropdown-item>
                  <el-dropdown-item icon="el-icon-switch-button">
                    <span @click="log_out()">注销</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            
            <span style="text-align: right; float: right; font-size: 15px; font-weight:bold; "> {{ is_admin }}</span>
            <span style="text-align: right; float: right; font-size: 15px; font-weight:bold; margin-right: 15px;"> {{ username }} </span>
            


          </el-header>
          
          
          
          <div class="app-wrap">
          <!-- 此处放置el-tabs代码 -->
          <div >
            <el-tabs
              v-model="activeIndex"
              type="card"
              closable
              v-if="openTab.length"
              @tab-click='tabClick'
              @tab-remove='tabRemove'
              >
              <el-tab-pane
              :key="item.name"
              v-for="item in openTab"
              :label="item.name"
              :name="item.route"
              >
              </el-tab-pane>
            </el-tabs>
          </div>

          <div class="el-main-style">
            <router-view/>
          </div>

        </div>

        </el-container>
      </el-container>
    </div>
  </div>
</template>



<script>
  
export default {
  components: {
    // index_info: index_info,
    // shop_list: shop_list,
    // add_shop: add_shop,
    // room_list: room_list,

  },
  data() {
    return {
      isCollapse: false,
      
        
      username: '',
      userId: '',
      avatar: '../assets/touxiang.jpg',
      is_admin: '',

        
     
      
      menuList:[
        {
          id:'1',
          title: '店铺管理',
          icon:'el-icon-s-shop',
          children:[
            {
              index:'/shop_list',
              icon:'el-icon-house',
              childtitle:'店铺列表'
            },
            {
              index:'/room_list',
              icon:'el-icon-copy-document',
              childtitle:'包间列表'
            },
            {
              index:'/order_system',
              icon:'el-icon-s-order',
              childtitle:'订单管理'
            },
          ]
        },
        {
          id:'2',
          title: '通用配置',
          icon:'el-icon-document-checked',
          children:[
            {
              index:'/deploy_play',
              icon:'el-icon-document',
              childtitle:'玩法配置'
            },
            {
              index: '/banner_system',
              icon:'el-icon-picture',
              childtitle:'banner管理'
            },
            {
              index: '/work_order_system',
              icon:'el-icon-s-claim',
              childtitle:'工单管理'
            },
            {
              index: '/device_system',
              icon:'el-icon-mobile-phone',
              childtitle:'设备管理'
            }
          ]
        },
				{
          id:'3',
          title: '系统管理',
          icon:'el-icon-s-grid',
          children:[
            {
              index:'/user_system',
              icon:'el-icon-s-custom',
              childtitle:'角色管理'
            },
						{
              index:'/job_system',
              icon:'el-icon-office-building',
              childtitle:'岗位管理'
            },
						{
              index:'/department_system',
              icon:'el-icon-s-claim',
              childtitle:'部门管理'
            },
            {
              index:'/ordinary_user_system',
              icon:'el-icon-user',
              childtitle:'普通用户管理'
            },
            
          ]
        },
        {
          id: '4',
          title: '活动管理',
          icon:'el-icon-s-ticket',
          children:[
            {
              index:'/activity_system',
              icon:'el-icon-s-ticket',
              childtitle:'活动策划'
            },
            {
              index:'/coupon_system',
              icon:'el-icon-s-data',
              childtitle:'优惠券列表'
            },
            {
              index: '/coupon_type_system',
              icon:'el-icon-s-data',
              childtitle:'优惠券管理'
            }
  
          ]
        },
        {
          'id': '5',
          title: '会员管理',
          icon:'el-icon-star-on',
          children: [
            {
              index: 'vip_privilege_system',
              icon: 'el-icon-s-check',
              childtitle: '会员特权管理'
            },
            {
              index: 'vip_recharge_system',
              icon: 'el-icon-s-goods',
              childtitle: '会员充值管理'
            },
            {
              index: 'vip_points_system',
              icon: 'el-icon-s-check',
              childtitle: '会员积分管理'
            }
          ]
        },
        {
          id: '6',
          title: '其他管理',
          icon:'el-icon-s-grid',
          children: [
            {
              index: '/feedback_system',
              icon:'el-icon-s-comment',
              childtitle:'意见反馈'
            },
            {
              index: '/settled_system',
              icon:'el-icon-s-shop',
              childtitle: '加盟管理'
            },
            {
              index: 'faq_system',
              icon:'el-icon-s-help',
              childtitle:'常见问题'
            },
            {
              index: 'message_system',
              icon:'el-icon-s-comment',
              childtitle:'消息管理'
            },
            {
              index: 'service_system',
              icon:'el-icon-phone-outline',
              childtitle:'客服管理'
            }
          ]
        }
      ]
    }
  },

  mounted () {
    // 刷新时以当前路由做为tab加入tabs
    // 当前路由不是首页时，添加首页以及另一页到store里，并设置激活状态
    // 当当前路由是首页时，添加首页到store，并设置激活状态

    if (this.$route.path !== '/' && this.$route.path !== '/main') {
    console.log('1');
    this.$store.commit('add_tabs', {route: '/main' , name: '首页'});
    this.$store.commit('add_tabs', {route: this.$route.path , name: this.$route.name});
    this.$store.commit('set_active_index', this.$route.path);
    } else {
    console.log('2');
    this.$store.commit('add_tabs', {route: '/main', name: '首页'});
    this.$store.commit('set_active_index', '/main');
    this.$router.push('/');
    }

    // 获取当前登录用户信息
    this.getUserInfo()

  },
  
  methods: {

    // 获取当前登录用户信息
    async getUserInfo () {
      this.userId = window.sessionStorage.getItem('id')
      // 请求当前用户信息
      let res = await this.$axios.get('/api/users/' + this.userId + '/')
      this.username = res.data.username
      this.avatar = res.data.avatar

      // 当前用户身份
      let is_super_admin = res.data.is_super_admin
      if (is_super_admin) {
          this.is_admin = "超级管理员"
        } else {
          this.is_admin = "普通员工"
      }


    },
    
    
    // 展开和关闭导航标签事件
    OpenCloseTable(){
      
      if (this.isCollapse === false){
        this.isCollapse = true
      }
      else {
        this.isCollapse = false
      }
        
    },
    
    //tab标签点击时，切换相应的路由
    tabClick(tab){
      console.log("tab",tab);
      console.log('active',this.activeIndex);
      this.$router.push({path: this.activeIndex});
    },
    //移除tab标签
    tabRemove(targetName){
      console.log("tabRemove",targetName);
      //首页不删
      if(targetName == '/'||targetName == '/main'){
        return
      }
      this.$store.commit('delete_tabs', targetName);
      if (this.activeIndex === targetName) {
        // 设置当前激活的路由
        if (this.openTab && this.openTab.length >= 1) {
          console.log('=============',this.openTab[this.openTab.length-1].route)
          this.$store.commit('set_active_index', this.openTab[this.openTab.length-1].route);
          this.$router.push({path: this.activeIndex});
        } else {
          this.$router.push({path: '/'});
        }
      }
    },

    // 个人中心
    user_personal(){
      console.log('goto user')
      this.$router.push('/user_personal')
    },

    // 注销
    log_out(){
      console.log('注销')
      window.sessionStorage.removeItem('token')
      // 跳转到登录页面
      this.$router.push('/login')
    }
    
  },
  
  computed: {
    openTab () {
    return this.$store.state.openTab;
    },
    activeIndex:{
    get () {
      return this.$store.state.activeIndex;
    },
    set (val) {
      this.$store.commit('set_active_index', val);
    }
    }
  },

  watch:{
  '$route'(to,from){
    //判断路由是否已经打开
    //已经打开的 ，将其置为active
    //未打开的，将其放入队列里
    let flag = false;
    for(let item of this.openTab){
      console.log("item.name",item.name)
      console.log("t0.name",to.name)

      if(item.name === to.name){
      console.log('to.path',to.path);
      this.$store.commit('set_active_index',to.path)
      flag = true;
      break;
      }
    }

    if(!flag){
      console.log('to.path',to.path);
      this.$store.commit('add_tabs', {route: to.path, name: to.name});
      this.$store.commit('set_active_index', to.path);
    }

  }
  }



}

</script>

<style>
  /* .el-tabs__header {
    margin: 0px;
  } */
  
  .el-main-style {
    /* background-color: #fff; */
    /* border:10px solid #e4e7ed; */
    background-color: #fff;
    /* display:table-header-group; */
    padding: 0;
    height: 87vh !important;
    
  }
  
  .is-open-close-btn {
    font-size: 24px;
    width: 60px;
    position: absolute;
    text-align: center;
    margin-left: -20px;
  }
  
  .is-open-close-btn:hover{
    background-color: #eeeeee !important;
  }
  
  .el-header {
    /* padding: 0px; */
  background-color: #B3C0D1;
  color: #333;
  line-height: 60px;
  }
  
  .el-aside {
  color: #333;
  }
  
  .el-menu-hideen {
    transition: all .3s;
  }
  
  .main-style-open .my-aside {
    background-color: #191a23;
    -webkit-transition: width .3s;
    transition: width .3s;
    width: 220px;
    height: 100%;
    position: fixed;
    font-size: 0;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow: hidden;
    
  }
  
  .main-style-close .my-aside {
    background-color: #191a23;
    -webkit-transition: width .3s;
    transition: width .3s;
    width: 64px;
    height: 100%;
    position: fixed;
    font-size: 0;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow: hidden;
  }
  
  .main-style-open 	.main-container {
    /* --el-main-padding: 20px; */
    min-height: 100%;
    transition: margin-left .3s;
    margin-left: 220px;
    position: relative;
    background-color: #fff;
    /* background-color: #f0f2f5; */
    overflow: auto;
    padding: 0;
    display: block;
    flex: 1;
    flex-basis: auto;
    height: 100vh!important;
  }
  
  .main-style-close .main-container {
    /* --el-main-padding: 20px; */
    min-height: 100%;
    transition: margin-left .3s;
    margin-left: 64px;
    position: relative;
    background-color: #fff;
    /* background-color: #f0f2f5; */
    overflow: auto;
    padding: 0;
    display: block;
    flex: 1;
    flex-basis: auto;
    height: 100vh!important;
  }
  

  
  .main-container-hidden {
    margin-left: 64px;
  }
  

  
  .my-aside-hidden {
    width: 64px;
  }
  
  
  .close_table {
    -webkit-transition: width .3s;
    transition: width .3s;
    -webkit-transition: background .3s;
    transition: background .3s;
  }
  
  .fix-title {
    min-height: 60px;
    line-height: 60px;
    text-align: center;
    transition: all .3s;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    
  }
  
  .logoimg {
    width: 30px;
    height: 30px;
    vertical-align: middle;
    background: #fff;
    border-radius: 50%;
    padding: 3px;
  }
  
  .user-icon-div {
    display: inline-block;
    position: relative;
    color: #606266;
    font-size: 14px;
    text-align: center;
  }
  
  .user-icon {
    width: 40px;
    height: 40px;
    vertical-align: middle;
    background: #fff;
    border-radius: 50%;
    padding: 3px;
  }
  
  .title-txt {
    display: inline-block;
    color: #fff;
    font-weight: 600;
    font-size: 20px;
    vertical-align: middle;
    padding-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .displaynone {
    display: none;
  }

  /* 隐藏滚动条 */
  .my-aside ::-webkit-scrollbar{
    display: none;
  }

  
  
</style>
